module.exports = __webpack_public_path__ + "img/productions_39.00bce45c.png";